import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import PersonalDetailForm from '../forms/PersonalDetails';

class Security extends React.Component {

  componentDidMount() {}

  async submitForm() {
    await this.personalDetailForm.submitForm();
  }

  render() {
    return (
      <div className="inf-panel">
        <p className="inf-panel-title">Security</p>
        <p className="inf-panel-sub">Password and account protection.</p>
        <hr className="inf-panel-divider" />
        <Grid container>
          <Grid item xs={12} md={9}>
            <PersonalDetailForm
              onRef={(ref) => (this.personalDetailForm = ref)}
              fieldsToShow={['email', 'phone_number', 'change_password']}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withRouter(Security);
